import axios from 'axios';
import { getApiBaseUrl } from './utils';

export async function fetchWebCheckoutUrl(token) {
  const response = await axios.get(`${getApiBaseUrl()}/api/auth/subscription/web/checkout-url`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}

export async function linkWebSubscription(token, payload) {
  const response = await axios.post(`${getApiBaseUrl()}/api/auth/subscription/web/link`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}

export async function refreshWebSubscription(token) {
  const response = await axios.post(`${getApiBaseUrl()}/api/auth/subscription/web/refresh`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}

export async function fetchWebManageUrl(token) {
  const response = await axios.get(`${getApiBaseUrl()}/api/auth/subscription/web/manage-url`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}
